export default __webpack_public_path__ + "static/media/vChurchill.873c5c0e.png";